import _ from 'lodash';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { connect } from 'react-redux';
import * as IntercomActions from '../../redux/actions/intercom.actions';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import VirtualIntercomRow from './VirtualIntercomRow.jsx';

@connect(state => ({
  intercom: state.intercom,
  viewLoading: state.utils.viewLoading,
  themeName: state.settings.items.theme.data.themeName,
  routing: state.router,
}))
class VirtualIntercomListView extends React.Component {
  
  appendVirtualIntercoms(page) {
    const { dispatch } = this.props;
    dispatch(IntercomActions.appendIntercoms(page));
  }

  render() {
    const { intercom: { selectedIntercom, data: { content: intercomData, pagination: { number: currentPage, totalPages } } }, onSelectVirtualIntercom, onNewVirtualIntercom, viewLoading, themeName } = this.props;
    return (
      <div className="list-view details-section" style={{ top: 190, paddingBottom: 40, width: '90%', overflow: 'auto' }}>
        <InfiniteScroll
          initialLoad={false}
          loadMore={() => this.appendVirtualIntercoms(currentPage + 1)}
          hasMore={currentPage + 1 < totalPages}
          loader={<ListLoadingView />}
          useWindow={false}
        >
          <div className="r-full-width-phone" style={{ width: '41%' }}>
            {!_.isEmpty(intercomData) ?
              _.map(intercomData, intercom =>
                <VirtualIntercomRow
                  themeColor={themeName}
                  key={intercom.id}
                  isSelected={selectedIntercom && selectedIntercom.id === intercom.id}
                  intercom={intercom}
                  onClick={() => onSelectVirtualIntercom(intercom)}
                />)
                : (
                  <div>
                    {!viewLoading ? (
                      <EmptyView
                        title="noVirtualIntercoms"
                        onNewEntity={null}
                        newEntityTitle={null}
                        subtitle="noVirtualIntercomsDescription"
                        iconName="icon-simple-line-icons-user-following"
                      />) : <ListLoadingView />}
                  </div>
                )
              }
          </div>
        </InfiniteScroll>
      </div>
    );
  }
}

export default VirtualIntercomListView; 